module.exports = __webpack_public_path__ + "img/dice-yxx3-3.8313ac29.svg";